import { GET, POST } from '../request'

export const getDocumento = ({ id }) =>
  GET('/api/core/interno/documento-csv', { id })

export const getDocumentos = ({ mes }) =>
  GET('/api/core/interno/documento-csv/list', { mes })

export const createDocumento = ({ url, mes }) => POST(url, { mes })
